import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ACTORS_QUERY_KEYS } from "Actors/Api/Queries/queryKeys";
import { postActors, type SaveActorRequest } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export function useCreateActorMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse((request: SaveActorRequest) =>
      postActors(request),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ACTORS_QUERY_KEYS.all,
        exact: false,
      });
    },
  });
}
